import BrandArticle from "@/pages/article/components/BrandArticle";
import { brandArticles } from "@/mocks/brandArticles";

const data = brandArticles.find((a) => a.slug === "oopbuy-spreadsheet")!;

export default function OopbuySpreadsheetPage() {
  return <BrandArticle data={data} />;
}